import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import CardHelpLink from "../CardHelpLink";
import UserGoBack from "../../user/UserGoBack";
import { useNavigate } from "react-router-dom";
import RightPartContent from "../RightPartContent";
import IndexLinks from "../IndexLinks";

const HelpTopicInscriptionIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Vos inscriptions", link: '/topics/inscription'},
  ]

  const links = [
    { title: 'Mes inscriptions', link: '/topics/inscription/38'},
    { title: 'Règlement file d\'attente', link: '/topics/inscription/64'},
    { title: 'Modifications', link: '/topics/inscription/modification'},
    { title: 'Annulations', link: '/topics/inscription/annulations'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicInscriptionIndex